import React from "react";
import { Typography } from "@material-ui/core";
import { useStyles } from "./projectStyle";

export default function Relier() {
  const classes = useStyles();
  var accentColor = "#D1F1FF";

  return (
    <div>
      <div className={classes.header} style={{ backgroundColor: accentColor }}>
        <div className={classes.content} style={{ paddingBottom: 0 }}>
          <Typography variant="h2">Relier</Typography>
        </div>
        <img
          className={classes.headerImage}
          src="/assets/relier/feature.png"
          alt="relier"
        />
      </div>
      <div className={classes.content}>
        <Typography variant="h2" className={classes.section}>
          Overview
        </Typography>
        <Typography>
          The 2020 pandemic has drastically changed the way people meet and
          interact. Most companies are now doing all their meetings online and
          many schools use online classrooms to give lectures.
          <br />
          <br />
          For many people, adapting to teleconferencing has been a big
          challenge. This project is an attempt to improve interactions between
          hosts and participants of online meetings.
        </Typography>

        <Typography variant="h2" className={classes.section}>
          Problem
        </Typography>
        <Typography>
          Having assisted in numerous online meetings and classes, and
          discussing these issues fellow users, it became clear that
          communication between the host and the participants is often
          dysfunctional.
          <br /><br />
          We have been able to identify some recurring issues:
          <ul>
            <li>
              Non-verbal feedback such as raised hands and chat messages aren't
              visible enough and can be diluted
            </li>
            <li>Notifications are often missed, or noticed too late</li>
            <li>
              The usual visual cues like hand gestures or audience reactions are
              missing (e.g.: Cameras not turned on and not being able to see all
              participants on screen)
            </li>
            <li>
              It's difficult to signal urgent problems, such as a choppy audio
              due to a bad connection
            </li>
          </ul>
        </Typography>

        <Typography variant="h2" className={classes.section}>
          Process
        </Typography>
        <img
          className={classes.fullImage}
          src="/assets/relier/process.png"
          alt="process"
        />
        <Typography style={{ marginTop: "5em", textAlign: "center" }}>
          Design evolution and outcomes coming soon!
        </Typography>
      </div>
    </div>
  );
}
